import httpAuth from '@/services/httpAuth'

export async function uploadArteFinal (formData, arteID) {
  return httpAuth.post(`/crm/uploadartefinal/${arteID}`, formData)
}

export async function enviarEmailAprovacao (data) {
  return httpAuth.post('/crm/enviaremailaprovacao', data)
}

export async function apiFinalizarProcesso (data) {
  return httpAuth.post('/crm/finalizarprocessoarte', data)
}

export async function apiCancelarProcesso (data) {
  return httpAuth.post('/crm/cancelarprocessoarte', data)
}

export async function apiExcelArtesPersonalizadas (filtros) {
  return httpAuth.post(`/crm/controleartes/exportarexcel?${filtros}`)
}

export async function apiExcluirArteS3 (data) {
  return httpAuth.post('/crm/excluirartes3', data)
}

export async function apiExcelArtesEnvios (filtros) {
  return httpAuth.post(`/crm/controleartes/exportarenviosexcel?${filtros}`)
}
